/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { createEntity, getEntity, reset, updateEntity } from './lab-hospital-association.reducer';

export const LabHospitalAssociationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const labHospitalAssociationEntity = useAppSelector(state => state.labHospitalAssociation.entity);
  const loading = useAppSelector(state => state.labHospitalAssociation.loading);
  const updating = useAppSelector(state => state.labHospitalAssociation.updating);
  const updateSuccess = useAppSelector(state => state.labHospitalAssociation.updateSuccess);

  const handleClose = () => {
    navigate(`/lab-hospital-association${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiagLabs({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.associatedDate !== undefined && typeof values.associatedDate !== 'number') {
      values.associatedDate = Number(values.associatedDate);
    }
    if (values.leavingDate !== undefined && typeof values.leavingDate !== 'number') {
      values.leavingDate = Number(values.leavingDate);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.createdDtm !== undefined && typeof values.createdDtm !== 'number') {
      values.createdDtm = Number(values.createdDtm);
    }

    const entity = {
      ...labHospitalAssociationEntity,
      ...values,
      diagLab: diagLabs.find(it => it.id.toString() === values.diagLab?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...labHospitalAssociationEntity,
          diagLab: labHospitalAssociationEntity?.diagLab?.id,
          hospital: labHospitalAssociationEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.labHospitalAssociation.home.createOrEditLabel" data-cy="LabHospitalAssociationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.labHospitalAssociation.home.createOrEditLabel">
              Create or edit a LabHospitalAssociation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="lab-hospital-association-id"
                  label={translate('tinyMedicRestApp.labHospitalAssociation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.associatedDate')}
                id="lab-hospital-association-associatedDate"
                name="associatedDate"
                data-cy="associatedDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.leavingDate')}
                id="lab-hospital-association-leavingDate"
                name="leavingDate"
                data-cy="leavingDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.timestampentry')}
                id="lab-hospital-association-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.microSec')}
                id="lab-hospital-association-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.lastupdated')}
                id="lab-hospital-association-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.active')}
                id="lab-hospital-association-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.cursor')}
                id="lab-hospital-association-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.openingTime')}
                id="lab-hospital-association-openingTime"
                name="openingTime"
                data-cy="openingTime"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.closeTime')}
                id="lab-hospital-association-closeTime"
                name="closeTime"
                data-cy="closeTime"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.internal')}
                id="lab-hospital-association-internal"
                name="internal"
                data-cy="internal"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.createdDtm')}
                id="lab-hospital-association-createdDtm"
                name="createdDtm"
                data-cy="createdDtm"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.createdBy')}
                id="lab-hospital-association-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.modifiedBy')}
                id="lab-hospital-association-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labHospitalAssociation.leftAssociation')}
                id="lab-hospital-association-leftAssociation"
                name="leftAssociation"
                data-cy="leftAssociation"
                check
                type="checkbox"
              />
              <ValidatedField
                id="lab-hospital-association-diagLab"
                name="diagLab"
                data-cy="diagLab"
                label={translate('tinyMedicRestApp.labHospitalAssociation.diagLab')}
                type="select"
                required
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="lab-hospital-association-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.labHospitalAssociation.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/lab-hospital-association" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LabHospitalAssociationUpdate;
